import { staticURL } from "../Utilities";

export const birthdayCelebration = staticURL("/images/birthday-celebration.png");
export const creativePerson1 = staticURL("/images/creative-person-1.png");
export const seeLearningLogo = staticURL("/images/see-learning-logo.svg");
export const seeLearningLogoAndWordmark = staticURL("/images/see-learning-logo-and-wordmark.svg");
export const studentBoy1 = staticURL("/images/student-boy-1.svg");
export const studentGirl1 = staticURL("/images/student-girl-1.svg");
